/** English labels for the sheet: the Snapshot's strings and tables when present, Foundry's defaults otherwise. */
import type { EngineState } from "./state";

/** A localisation key's text, or the fallback when the Snapshot does not carry it. */
export function localize(state: EngineState | null, key: string, fallback: string, values: Record<string, string | number> = {}): string {
  const text = state?.catalogue?.localize(key) ?? key;
  const template = text === key ? fallback : text;
  return template.replace(/\{(\w+)\}/g, (whole, name: string) => (name in values ? String(values[name]) : whole));
}

/** A value's label from a Snapshot table, or the value spelled out ("deadly-d10" -> "Deadly d10"). */
export function tableLabel(state: EngineState | null, table: string | string[], value: string): string {
  for (const name of Array.isArray(table) ? table : [table]) {
    const label = state?.catalogue?.table(name)?.[value];
    if (label) return label;
  }
  return prettify(value);
}

/** "deadly-d10" -> "Deadly d10", "cold-iron" -> "Cold Iron", "two-hand-d12" -> "Two Hand d12". */
export function prettify(slug: string): string {
  return slug
    .split("-")
    .map((part) => (/^\d*d\d+$/.test(part) ? part : part.charAt(0).toUpperCase() + part.slice(1)))
    .join(" ");
}

export function weaponTraitLabel(state: EngineState | null, trait: string): string {
  return tableLabel(state, ["weaponTraits", "npcAttackTraits"], trait);
}

export function damageTypeLabel(state: EngineState | null, type: string): string {
  return tableLabel(state, "damageTypes", type);
}
